import { Button } from '@mui/material'
import type React from 'react'
import { useContext } from 'react'
import { LanguageContext } from '../util/LanguageContext'

type ConversationImageDelButtonProps = {
  onClick: () => void
}

export const ConversationImageDelButton: React.FC<ConversationImageDelButtonProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)

  return (
    <>
      <Button
        onClick={props.onClick}
        sx={{
          justifyContent: 'center',
          color: '#FFFFFF',
          font: 'normal normal bold 21px/29px Noto Sans JP',
          textAlign: 'center',
          backgroundColor: '#FF0000',
          '&:hover': {
            backgroundColor: '#FF0000',
            opacity: 0.7,
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '49px',
          width: '181px',
          borderRadius: '10px',
          alignItems: 'center',
        }}
      >
        {translation['button_delete']}
      </Button>
    </>
  )
}
